// services/notificationService/map.ts — DB snake_case → tipe Notification.
// Sekaligus normalisasi tipe legacy (abandoned_cart/order_status_*) ke kunci
// kanonik agar ikon, badge, dan tab filter cocok (tanpa ini semua jatuh ke
// DEFAULT + isRead undefined + createdAt undefined = "Invalid Date").
import type { Notification, NotificationType } from '../../types';

const TYPE_ALIAS: Record<string, NotificationType> = {
  abandoned_cart: 'CART_ABANDON',
  order_status: 'ORDER_STATUS',
  order_status_change: 'ORDER_STATUS',
  order_status_changed: 'ORDER_STATUS',
  new_order: 'ORDER_NEW',
};

export function normalizeNotificationType(raw: unknown): NotificationType {
  if (typeof raw !== 'string') return 'ORDER_NEW';
  return TYPE_ALIAS[raw] ?? (raw as NotificationType);
}

export function mapRowToNotification(n: any): Notification {
  return {
    id: n.id,
    userId: n.user_id,
    type: normalizeNotificationType(n.type),
    title: n.title || '',
    message: n.message,
    metadata: n.metadata,
    isRead: !!n.is_read,
    isDeleted: !!n.is_deleted,
    createdAt: n.created_at,
    updatedAt: n.updated_at,
    readAt: n.read_at,
  };
}
